import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";

const EmployeeInformation = React.lazy(() =>
  import("@/pages/separation/employee/EmployeeInformation")
);
const ReportingManager = React.lazy(() =>
  import("@/pages/separation/employee/ReportingManager")
);
const Reviewer = React.lazy(() =>
  import("@/pages/separation/employee/Reviewer")
);
const ExitInterview = React.lazy(() =>
  import("@/pages/separation/employee/ExitInterview")
);
const NodueClearanceStatus = React.lazy(() =>
  import("@/pages/separation/employee/NodueClearanceStatus")
);
const ITInfra = React.lazy(() => import("@/pages/separation/itInfra/ITInfra"));
const SiteAdmin = React.lazy(() =>
  import("@/pages/separation/siteAdmin/SiteAdmin")
);
const Finance = React.lazy(() => import("@/pages/separation/finance/Finance"));
const Report = React.lazy(() => import("@/pages/separation/hr/Report"));
const AccountInfoApproval = React.lazy(() =>
  import("@/pages/separation/hr/AccountInfoApproval")
);
const HRReport = React.lazy(() => import("@/pages/separation/hr/HRReport"));
const DevposReport = React.lazy(() =>
  import("@/pages/separation/hr/DevposReport")
);
const Action = React.lazy(() => import("@/pages/separation/hr/Action"));

const Separations = [
  {
    path: "employeeInfoSeparation",
    element: (
      <SuspenseWrapper>
        <EmployeeInformation />
      </SuspenseWrapper>
    ),
  },
  {
    path: "reportingManagerSeparation",
    element: (
      <SuspenseWrapper>
        <ReportingManager />
      </SuspenseWrapper>
    ),
  },
  {
    path: "reviewerSeparation",
    element: (
      <SuspenseWrapper>
        <Reviewer />
      </SuspenseWrapper>
    ),
  },
  {
    path: "exitInterview",
    element: (
      <SuspenseWrapper>
        <ExitInterview />
      </SuspenseWrapper>
    ),
  },
  {
    path: "noduesClearanceStatus",
    element: (
      <SuspenseWrapper>
        <NodueClearanceStatus />
      </SuspenseWrapper>
    ),
  },
  {
    path: "itInfraNoduesCertificate",
    element: (
      <SuspenseWrapper>
        <ITInfra />
      </SuspenseWrapper>
    ),
  },
  {
    path: "adminNoduesCertificate",
    element: (
      <SuspenseWrapper>
        <SiteAdmin />
      </SuspenseWrapper>
    ),
  },
  {
    path: "financeNoduesCertificate",
    element: (
      <SuspenseWrapper>
        <Finance />
      </SuspenseWrapper>
    ),
  },
  {
    path: "hrOpsNoduesCertificate",
    element: (
      <SuspenseWrapper>
        <HRReport />
      </SuspenseWrapper>
    ),
  },

  {
    path: "accountInfoApprovalSeparation",
    element: (
      <SuspenseWrapper>
        <AccountInfoApproval />
      </SuspenseWrapper>
    ),
  },
  {
    path: "separationReport",
    element: (
      <SuspenseWrapper>
        <Report />
      </SuspenseWrapper>
    ),
  },
  {
    path: "devposSeparationReport",
    element: (
      <SuspenseWrapper>
        <DevposReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "separationAction",
    element: (
      <SuspenseWrapper>
        <Action />
      </SuspenseWrapper>
    ),
  },
];

export default Separations;
